"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const intl_1 = require("@kyruus/intl");
const prop_types_1 = require("prop-types");
const DatePicker_1 = __importDefault(require("./DatePicker"));
const styles_1 = require("./styles");
const messages_1 = __importDefault(require("../../../lib/messages"));
const WeekDayFilter_1 = __importStar(require("../WeekDayFilter"));
const TimeFilter_1 = __importStar(require("../TimeFilter"));
const FilterButton_1 = __importDefault(require("./FilterButton"));
const FiltersToolbar = ({ filterBy, onDayOfWeekChange, onTimeOfDayChange, onDateChange, onClose, selectedDate, intl, track }) => {
    // sorted selected days
    const dayFilterVal = [...filterBy.dayOfWeek]
        .reduce((acc, dayIndex) => {
        acc[dayIndex] = WeekDayFilter_1.DAYS_OF_WEEK[dayIndex];
        return acc;
    }, [])
        .filter(Boolean);
    const timeFilterVal = filterBy.timeOfDay.size === 0 || filterBy.timeOfDay.has(TimeFilter_1.TIME_OF_DAY.ALL)
        ? TimeFilter_1.TIME_OF_DAY.ALL
        : [...filterBy.timeOfDay].join(', ');
    return (react_1.default.createElement(styles_1.FilterContainer, { "data-testid": "ApptList__JumpToDate", className: "filter_toolbar__container" },
        react_1.default.createElement(styles_1.FilterOptionsWrapper, null,
            react_1.default.createElement(DatePicker_1.default, { date: selectedDate, onDateChange: onDateChange, onClose: onClose }),
            react_1.default.createElement(styles_1.DayTimeFiltersWrapper, null,
                react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.apptTimeFilterBy), (FormattedMessage) => (react_1.default.createElement(styles_1.FilterByMessage, { className: "FilterByMessage" }, FormattedMessage))),
                react_1.default.createElement(FilterButton_1.default, { dataTestId: "ApptList__JumpToDate-DayOfWeek", active: dayFilterVal.length !== 0, btnAriaLabel: intl.formatMessage(messages_1.default.ariaJumpToDateFilterDayOfWeekButton), btnText: dayFilterVal.length ? (dayFilterVal.map((item) => item.slice(0, 3)).join(', ')) : (react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.apptTimeFilterDayOfWeek))), popoverDirection: "left", onOpen: () => {
                        track('user_action.direct_book.jump_to_date.day_of_week');
                    } },
                    react_1.default.createElement(WeekDayFilter_1.default, { filterBy: filterBy, onChange: onDayOfWeekChange })),
                react_1.default.createElement(FilterButton_1.default, { dataTestId: "ApptList__JumpToDate-TimeOfDay", active: timeFilterVal !== TimeFilter_1.TIME_OF_DAY.ALL, btnAriaLabel: intl.formatMessage(messages_1.default.ariaJumpToDateFilterTimeOfDayButton), btnText: timeFilterVal !== TimeFilter_1.TIME_OF_DAY.ALL ? (timeFilterVal) : (react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.apptTimeFilterTimeOfDay))), popoverDirection: "right", onOpen: () => {
                        track('user_action.direct_book.jump_to_date.time_of_day');
                    } },
                    react_1.default.createElement(TimeFilter_1.default, { filterBy: filterBy, onChange: onTimeOfDayChange }))))));
};
FiltersToolbar.defaultProps = {
    selectedDate: ''
};
FiltersToolbar.propTypes = {
    selectedDate: prop_types_1.string,
    onDateChange: prop_types_1.func.isRequired,
    onClose: prop_types_1.func,
    onDayOfWeekChange: prop_types_1.func.isRequired,
    onTimeOfDayChange: prop_types_1.func.isRequired,
    filterBy: prop_types_1.object.isRequired,
    intl: (0, prop_types_1.shape)({
        formatMessage: prop_types_1.func.isRequired
    }).isRequired,
    track: prop_types_1.func
};
exports.default = (0, intl_1.injectIntl)(FiltersToolbar);
//# sourceMappingURL=FiltersToolbar.js.map